/**
 * Styled Components - Created by gustavomedina on 12/04/18.
 */
import styled from 'styled-components'

interface StyleProps {
  withBorder?: boolean
}

type StyledProps = {
  backgroundColor?: string
  showTooltips?: boolean
  isHovered?: boolean
  archived?: boolean
  withBorder?: boolean
  withMargin?: boolean
  selected?: boolean
  reverse?: boolean
  secondary?: boolean
}

export const Footer = styled.div`
  padding: var(--spacing-12) var(--spacing-16);
  @media (max-width: 767px) {
    padding: var(--spacing-8);
    display: flex;
    flex-flow: column;
    width: 100%;
    min-width: 0;
  }
`

export const Type = styled.div`
  color: var(--neutral-darkest);
  font: 600 16px/22px var(--font-barlow);
  letter-spacing: -0.1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media (max-width: 767px) {
    font: 600 14px/24px var(--font-barlow);
    letter-spacing: 0;
  }
`

export const Description = styled.div`
  margin-top: var(--spacing-2);
  color: var(--neutral-secondary);
  font: 400 12px/20px var(--font-inter);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &.code {
    color: var(--neutral-muted);
    font: 600 12px/18px var(--font-barlow);
    letter-spacing: 1px;
    text-transform: uppercase;
  }
`

export const ClosedNotice = styled.p`
  display: none;
  margin: 0;
  color: var(--neutral-muted);
  font: 400 12px/20px var(--font-inter);
  padding-bottom: var(--spacing-4);
  align-items: flex-end;
  flex: 1;
  @media (max-width: 767px) {
    display: flex;
  }
`

export const Bottom = styled.div`
  display: flex;
  flex-flow: column;
  margin-top: var(--spacing-4);
  .ant-progress-bg {
    background-color: var(--neutral-darkest);
  }
  .ant-progress-status-success .ant-progress-bg {
    background-color: var(--series-pro);
  }
  @media (max-width: 767px) {
    margin-top: 0;
    .ant-progress {
      line-height: 1;
      margin-bottom: 2px;
    }
  }
`

export const Label = styled.div<{$rightAlignment?: boolean}>`
  color: var(--neutral-muted);
  font: 600 12px/20px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
`

export const PriceLabel = styled.div`
  display: flex;
  user-select: none;
  color: var(--neutral-darkest);
  font: 600 20px/26px var(--font-barlow-semi-condensed);
  letter-spacing: 0.6px;
`

export const Price = styled.div`
  user-select: none;
  color: #5f6062;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`

export const Delete = styled.div`
  color: #e61737;
  font-size: 12px;
  line-height: 16px;
  cursor: pointer;
`

export const Private = styled.span`
  color: #8c8c8c;
  font-size: 12px;
  line-height: 16px;
`

export const BottomPrices = styled.div`
  display: flex;
  justify-content: space-between;
  border-top: var(--border-regular) solid var(--neutral-border-light);
  margin-top: var(--spacing-12);
  padding-top: var(--spacing-12);
  &:not([data-yotpo='true']) {
    @media (max-width: 767px) {
      margin-top: var(--spacing-8);
      padding-top: var(--spacing-8);
      flex-flow: column;
    }
  }
  &[data-yotpo='true'] > div {
    flex: 1;
    white-space: nowrap;
  }
`

export const PricesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${({ secondary }: StyledProps) => secondary ? `
    flex-flow: row;
    align-items: flex-end;
    .priceLabel {
      color: var(--neutral-secondary);
      font: 400 12px/20px var(--font-inter);
      letter-spacing: 0;
      text-transform: capitalize;
      margin-right: var(--spacing-8);
    }
    .priceAmount {
      color: var(--neutral-muted);
      font: 400 12px/20px var(--font-inter);
      letter-spacing: 0;
      text-decoration-line: line-through;
    }
    .no-dash {
      text-decoration: unset;
    }
    @media (max-width: 767px) {
      margin-top: 2px;
    }
  ` : ''}
  @media(max-width: 698px) {
    &:last-child {
      flex: 1;
      align-items: flex-end;
      .priceLabel {
        text-align: right;
      }
    }
  }
`

export const ContainerCurrentPrice = styled.div<{$marginTop?: boolean}>`
  ${props => props.$marginTop ? `margin-top: 10px; margin-bottom: 10px` : ''}
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 2px;
`

export const LabelCurrentPrice = styled.div`
  font-size: 14px;
`

export const ValuesContainerCurrentPrice = styled.div`
  display: flex;
  gap: 4px;
  font-size: 22px;
  font-weight: 600;
  align-items: baseline;
`

export const PercLabel = styled.div`
  color: var(--accent-red);
  font: 600 12px/20px var(--font-inter);
  margin-left: 2px;
`

export const AmountCurrentPrice = styled.div`
  display: flex;
  gap: 8px;
`

export const SignCurrentPrice = styled.span``

export const ContainerRegularPrice = styled.div`
  display: flex;
  gap: 6px;
  color: #c8c8c8;
  font-size: 10px;
`

export const LineThroughRegularPrice = styled.div`
  text-decoration: line-through;
`

export const ProgressText = styled.div`
  color: var(--neutral-secondary);
  font: 400 12px/20px var(--font-inter);
  b {
    color: var(--neutral-darkest);
  }
  @media (max-width: 767px) {
    font: 400 10px/14px var(--font-inter);
  }
`

export const SaveText = styled.div`
  color: var(--series-pro);
  font: 400 12px/20px var(--font-inter);
  strong {
    font-weight: 600;
  }
  @media (max-width: 767px) {
    font: 400 9px/14px var(--font-inter);
  }
`

export const ImgIcon = styled.img`
  height: 15px;
  margin-right: 5px;
  width: 15px;
  border-radius: 50%;
  ${({ withBorder }: StyleProps) => (withBorder ? 'border: 1px solid' : '')};
`

interface DivProps {
  secondary?: boolean
}

export const ColorName = styled.div`
  z-index: 2;
  color: #b0b0b0;
  font-size: 10px;
  mix-blend-mode: difference;
  white-space: nowrap;
  ${({ secondary }: DivProps) => (secondary ? `
    color: var(--neutral-white);
    mix-blend-mode: unset;
  ` : '')};
   @media (max-width: 767px) {
    font-size: 8px;
   }
`

export const CartWrapper = styled.div`
  display: none;
  flex: 1;
  align-items: flex-end;
  margin-top: 0;
  & > div {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    > div {
      border-radius: 0;
      height: 42px;
      letter-spacing: 1px;
      padding: var(--spacing-8) var(--spacing-16);
    }
  }
  @media (max-width: 767px) {
    display: flex;
    &[data-yotpo="true"] {
      margin-top: var(--spacing-12);
    }
  }  
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/FooterThumbnailTeamStoreV2/styledComponents.tsx